export default function Privacy() {
  return (
    <div>
      <h2>Privacy Policy</h2>

      <p>
        This application is a personal accounting and transaction tracking tool.
        It is intended for personal use by a single user.
      </p>

      <h3>Data Collected</h3>
      <ul>
        <li>Bank account metadata (institution name, account type)</li>
        <li>Transaction data (merchant, date, amount, category)</li>
      </ul>

      <h3>How Data Is Used</h3>
      <p>
        Data is used solely to display, review, and categorize personal financial
        transactions. Data is not sold, shared, or used for advertising.
      </p>

      <h3>Third-Party Services</h3>
      <p>
        This application uses Plaid to connect to financial institutions.
        Authentication credentials are never stored by this application.
      </p>

      <h3>Data Storage</h3>
      <p>
        Data is stored securely in a private database accessible only to the
        account owner.
      </p>

      <h3>Data Deletion</h3>
      <p>
        Users may delete all stored data at any time using the in-app deletion
        feature.
      </p>

      <h3>Contact</h3>
      <p>
        For questions regarding this policy, contact: youremail@example.com
      </p>
    </div>
  );
}
